import { AlunoPremiado } from "@/models/AlunoPremiado"

export default {
  nivel1: {
    ouro: [
      new AlunoPremiado('Josué Busetti'),
      new AlunoPremiado('Maria Clara Carneiro Duarte'),
      new AlunoPremiado('Samuel Nogueira Santiago')
    ],
    prata: [
      new AlunoPremiado('Gabriel Amorim Santiago'),
      new AlunoPremiado('Larissa Muniz Rocha Gadeha'),
      new AlunoPremiado('Alexandre Gonçalves Pinheiro'),
      new AlunoPremiado('Dante Penaforte Muratore'),
      new AlunoPremiado('João Vitor Veras Chaves'),
      new AlunoPremiado('Letícia Frota Barreto'),
      new AlunoPremiado('Pedro Silva do Nascimento')
    ],
    bronze: [
      new AlunoPremiado('Caio Moreira de Lima'),
      new AlunoPremiado('João Lucas Alves Ferreira'),
      new AlunoPremiado('Leonardo Fabricio Santana Magalhaes'),
      new AlunoPremiado('Lucas D\'alva Alves'),
      new AlunoPremiado('Murilo Alves Reis Neves'),
      new AlunoPremiado('Ronaldo Ponte de Aragao Rodrigues'),
      new AlunoPremiado('Vinícius Arthur Prado Firmeza'),
      new AlunoPremiado('Vinicius Martins Ribeiro')
    ],
    mencaoHonrosa: [
      new AlunoPremiado('Arthur Alencar Spuri'),
      new AlunoPremiado('Arthur Jales Alcântara'),
      new AlunoPremiado('Jose Ricardo de Moraes Costa Neto'),
      new AlunoPremiado('Leonardo Bezerra Peixoto'),
      new AlunoPremiado('Luiz Efraim Cavalcante Basílio'),
      new AlunoPremiado('Maria Eduarda Silva Matias'),
      new AlunoPremiado('Rafael Barrozo Siqueira'),
      new AlunoPremiado('Vittorio Queiroz Dall Olio')
    ]
  },
  nivel2: {
    ouroEspecial: [
      new AlunoPremiado('Levi Magalhaes Pereira Castello Branco')
    ],
    ouro: [
      new AlunoPremiado('Alessandro Mathias Machado'),
      new AlunoPremiado('Filipe Ya Hu Dai Lima')
    ],
    prata: [
      new AlunoPremiado('João Pedro Pitol Boeira de Castro'),
      new AlunoPremiado('Ana Carolina Albuquerque Nery'),
      new AlunoPremiado('Antonio Vinicius Candeira Soeiro Moreira'),
      new AlunoPremiado('Matheus Augustus Xerez Rios'),
      new AlunoPremiado('Pedro Moreira Carneiro Leite')
    ],
    bronze: [
      new AlunoPremiado('Cassio Cavalcante Colares'),
      new AlunoPremiado('Elias do Nascimento Barros'),
      new AlunoPremiado('Enzo Holanda Sampaio'),
      new AlunoPremiado('Juliana Souza Pinho'),
      new AlunoPremiado('Luiz Claudio de Sa Cavalcante Generoso'),
      new AlunoPremiado('Raul Saraiva Cavalcante')
    ],
    mencaoHonrosa: [
      new AlunoPremiado('Arthur Barroso Uchoa'),
      new AlunoPremiado('Cristian Levi de Souza Silveira'),
      new AlunoPremiado('Erico Alencar Brilhante'),
      new AlunoPremiado('Gabriel Mendes Freitas'),
      new AlunoPremiado('Julia Linhares de Aragao Rodrigues'),
      new AlunoPremiado('Laura Oliveira Mota'),
      new AlunoPremiado('Maria Gabriela Medeiros de Alencar Gonçalves'),
      new AlunoPremiado('Matheus Bezerra Walraven de Almeida'),
      new AlunoPremiado('Matheus Oliveira Quintela'),
      new AlunoPremiado('Tiago Rocha Morais de Santiago'),
      new AlunoPremiado('Tobias Gabriel Utz')
    ]
  },
  nivel3: {
    ouro: [
      new AlunoPremiado('Matheus Alencar de Moraes'),
      new AlunoPremiado('Rafael Martins Ruas'),
      new AlunoPremiado('Joao Guilherme Costa Viana'),
      new AlunoPremiado('Caio Harley Constancio Neves')
    ],
    prata: [
      new AlunoPremiado('Gabriella Santana Morgado'),
      new AlunoPremiado('Alan Mesquita Rios'),
      new AlunoPremiado('Fabricia Cardoso Marques'),
      new AlunoPremiado('Vitor de Oliveira da Silva'),
      new AlunoPremiado('Caique Paiva')
    ],
    bronze: [
      new AlunoPremiado('Isabela Ruthner Dorn'),
      new AlunoPremiado('Bilhana Plamenova Kochloukova'),
      new AlunoPremiado('Cecilia Mileski de Paula'),
      new AlunoPremiado('Darlan Vitor Albuquerque Franca'),
      new AlunoPremiado('Endy Lumy Okamura Miyashita'),
      new AlunoPremiado('Gabriel Seares Dellaroli'),
      new AlunoPremiado('João Victor Silva dos Santos'),
      new AlunoPremiado('Luiz Felipe Salviano Cruz')
    ],
    mencaoHonrosa: [
      new AlunoPremiado('Carlos Eduardo Pereira Sampaio'),
      new AlunoPremiado('Hericle de Lima de Moura'),
      new AlunoPremiado('João Paulo Pereira da Silva'),
      new AlunoPremiado('Levi Felix Barbosa'),
      new AlunoPremiado('Luca Zanardi Lamardo'),
      new AlunoPremiado('Luis Roberto Quintanilla Torrez'),
      new AlunoPremiado('Nicholas Farrel Ferraz de Faria'),
      new AlunoPremiado('Rodrigo Fontenele de Oliveira Linhares')
    ]
  }
}
